export { default } from './MrSpinnerVeil.vue';
